import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Container } from 'reactstrap';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import SummaryItem from './SummaryItem';
import SummaryChangeItem from './SummaryChangeItem';
import PDFSummary from './PDFSummary';
import { SummaryDocument,SummaryChangeDocument } from './PDFSummary';
import IDInput from './IDInput';
import { useHistory, Redirect } from "react-router-dom";
import FeedbackForm from './FeedbackForm'
import LoadingWheel from './LoadingWheel';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { MailIcon, FeedbackIcon } from './Icons';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Moment from 'react-moment';
import { pdf } from '@react-pdf/renderer';
import { DownloadIcon } from './Icons';
import moment from 'moment';
import { SnackbarProvider, VariantType, useSnackbar } from 'notistack';

const Summary = (props) => {
    const [questionResponses, setQuestionResponses] = useState([]);
    const [prevQuestionResponses, setPrevQuestionResponses] = useState([]);
    const [categories, setCategories] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [combinedQuestions, setCombinedQuestions] = useState([]);
    const [foundID, setFoundID] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState("Loading, please wait...");
    const [recallID, setRecallID] = useState('');
    const [showFeedbackForm, setShowFeedbackForm] = useState(false);
    const [emailing, setEmailing] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [appurl, setAppurl] = useState('');
    const [showError, setShowError] = useState(false);
    const [responseMeta, setResponseMeta] = useState();
    const [value, setValue] = React.useState(0);
    const [ducs, setDucs] = useState([]);
    const [excludeComment, setExcludeComment] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [noAddressAlert, setNoAddressAlert] = useState(); 
    const [subjectCode, setSubjectCode] = useState('');
    let downloadLink = useRef();
    let { uniqueID } = useParams();
    let { realID } = useParams();
    let { type } = useParams();
    let history = useHistory();

    useEffect(() => {
        if (type == "update") {
            // need to find previous DUC to compare
            axios.get('api/uniqueresponse/all/' + uniqueID, { withCredentials: true }).then(r => {
                setDucs(r.data);
                axios.get('api/summary/' + uniqueID + '/' + r.data[1].uniqueResponseID, { withCredentials: true }).then(response =>
                {
                    setPrevQuestionResponses(response.data);
                 
                });
            });
        }
    }, [type]);
    useEffect(() => {       
        var allques = [];
        questionResponses.forEach((sum) => {
            var q = {
                "questionID": sum.questionID,
                "questionText": sum.questionText,
                "categoryID": sum.categoryID,
                "questionDisplayOrder": sum.questionDisplayOrder
            }
            var found = allques.some(q => q.questionID == sum.questionID);
            if (!found) { allques.push(q); }
        });     
        setQuestions(allques);
    }, [questionResponses]);
    useEffect(() => {        
        var allques = [];
        questionResponses.forEach((sum) => {
            var q = {
                "questionID": sum.questionID,
                "questionText": sum.questionText,
                "categoryID": sum.categoryID,
                "questionDisplayOrder": sum.questionDisplayOrder
            }
            var found = allques.some(q => q.questionID == sum.questionID);
            if (!found) { allques.push(q); }
        });         
        prevQuestionResponses.forEach((sum) => {
            var q = {
                "questionID": sum.questionID,
                "questionText": sum.questionText,
                "categoryID": sum.categoryID,
                "questionDisplayOrder": sum.questionDisplayOrder
            }
            var found = allques.some(q => q.questionID == sum.questionID);
            if (!found) { allques.push(q); }
        });
        //setCombinedQuestions(allques.sort((n1, n2) => {
        //    return n1.questionDisplayOrder - n2.questionDisplayOrder
        //}));
        setCombinedQuestions(allques);
    }, [prevQuestionResponses, questionResponses]);
    useEffect(() => {
        // if historical, pass realID
        axios.get('api/uniqueresponse/' + uniqueID + (realID ? '/' + realID : ''), { withCredentials: true }).then(r => {
            setResponseMeta(r.data);
            var idtouse;
            if (!realID) {
                // if not historical, use ID of the latest one
                idtouse = r.data.uniqueResponseID;
            }
            // else get ID of historical
            else { idtouse = realID }
            axios.get('api/summary/' + uniqueID + '/' + idtouse, { withCredentials: true }).then(response => {
                setResponseMeta(r.data);
                setQuestionResponses(response.data);
                var allcat = [];
                response.data.forEach((sum) => {
                    var showSupport = false;
                    if (sum.responseText == "No evidence" || sum.responseText == "Some evidence") {
                        showSupport = true;
                    }
                    var cat = {
                        "categoryID": sum.categoryID,
                        "categoryText": sum.categoryText,
                        "showSupport": showSupport,
                        "categoryResources": sum.categoryResources
                    }
                    var found = allcat.some(c => c.categoryID == sum.categoryID);
                    if (!found) {
                        allcat.push(cat);
                    }
                    else {
                        // if a category already added, in case condition met, make sure showSupport is set to true
                        if (showSupport == true) {
                            var thiscat = allcat.find(function (item, i) {
                                if (item.categoryID === sum.categoryID) {
                                    item.showSupport = true;
                                }
                            });
                        }
                    }
                });

                setCategories(allcat);

               
                setLoading(false);
                setFoundID(true);
            }).catch(error => {
                setLoading(false);
                setFoundID(false);
            });




        }).catch(error => {
            setLoading(false);
            setFoundID(false);

        });

        axios.get('api/util/url').then(response => {
            setAppurl(response.data);
            console.log(response.data);
        });
    }, [uniqueID, realID]);
    const filterQuestions = (q, cid) => {
        var qr = questionResponses.find(qr => qr.questionID == q.questionID);
        if (q.categoryID == cid) {
            if (value == 1) {      
                var prevqr = prevQuestionResponses.find(qr => qr.questionID == q.questionID);
                return <SummaryChangeItem key={q.questionID} question={q} questionResponse={qr} prevQuestionResponse={prevqr} />;
             
            } else {
                // summary tab                         
                return <SummaryItem key={q.questionID} question={q} questionResponse={qr} />;
            }

        }
    }
   

    const handleShowFeedback = (e) => {
        e.preventDefault();
        setShowFeedbackForm(!showFeedbackForm);

    }
    const onRecallIDChange = (value) => {
        setRecallID(value);
    }
    const getSummaryBlob = () => {     
        if (value == 1) {
            return pdf(<SummaryChangeDocument appurl={appurl} subjectCode={subjectCode} categories={categories} questionResponses={questionResponses} prevQuestionResponses={prevQuestionResponses} questions={combinedQuestions} uniqueID={uniqueID} responseMeta={ducs[0]} prevResponseMeta={ducs[1]} excludeComment={excludeComment} response />).toBlob();

        } else {
            return pdf(<SummaryDocument appurl={appurl} subjectCode={subjectCode} categories={categories} questionResponses={questionResponses} questions={questions} uniqueID={uniqueID} facultyText={responseMeta.faculty} schoolText={responseMeta.unit} entity={responseMeta.entity} excludeComment={excludeComment} />).toBlob();
        }
    }
    const action = key => (
        <React.Fragment>
            <Button onClick={() => { closeSnackbar(key) }} className="errorDismissButton">
                Dismiss
        </Button>
        </React.Fragment>
    );
    const handleSend = (e) => {
        e.preventDefault();
     //   setLoadingMessage("Sending email, please wait...");
        //setLoading(true);
        if (emailAddress == "") {
            setNoAddressAlert(enqueueSnackbar("Please enter the email address you wish to send this summary to.",
                {
                    variant: 'error',
                    persist: true,  
                    action
                }
            ));
        } else {
        const emailalert = enqueueSnackbar("Sending email, please wait...", { variant: 'info', persist: true });
        getSummaryBlob().then(blob => {
                var reader = new FileReader();
                reader.onloadend = function (e2) {
                   // console.log("calling onload");
                    var rawLog = reader.result;
                    //  console.log(rawLog);
                    axios.post('api/mailer', {
                        "toAddress": emailAddress,
                        "uniqueID": uniqueID,
                        "pdfData": rawLog,
                        "fileName": "Digital_Uplift_Check_" + moment().format('YYYYMMDD') + ".pdf"
                    }).then(r2 => {
                        closeSnackbar(emailalert);
                        enqueueSnackbar("Email sent! Please allow 30 minutes for your summary to arrive.",
                            {
                                variant: 'success',
                                persist: true,
                                action
                            }
                        )
                    }).catch(error => {
                        closeSnackbar(emailalert);
                        enqueueSnackbar("Something went wrong, can't send email.",
                            {
                                variant: 'error',
                                persist: true,
                                action
                            }
                        )
                    });
                }
                reader.readAsDataURL(blob);
            });
        }

    }
    const handleDownload = (e) => {
        e.preventDefault();    
  
        const pdfalert = enqueueSnackbar("Generating PDF, please wait...", { variant: 'info', persist: true});

        getSummaryBlob().then(blob => {

            var reader = new FileReader();
            reader.onloadend = function (e2) {
                var rawLog = reader.result;
               // console.log(downloadLink.current);
                downloadLink.current.href = rawLog;
                downloadLink.current.download = "Digital_Uplift_Check_" + moment().format('YYYYMMDD') + ".pdf";
                downloadLink.current.click();
                closeSnackbar(pdfalert);
            };
            reader.readAsDataURL(blob);
        }).catch(error => { console.log(error) });
        
    }
    const changeEmailAddress = (e) => {
        if (e.target.value != "") {
            closeSnackbar(noAddressAlert);
        }
        setEmailAddress(e.target.value);
    }
    const changeSubjectCode = (e) => {
        setSubjectCode(e.target.value);
    }
    const handleRecallNext = (e) => {
        e.preventDefault();
        if (recallID == '') {
            setShowError(true);
        } else {
            axios.get('api/uniqueresponse/' + recallID, { withCredentials: true }).then(response => {
                history.push('/summary/recall/' + recallID + '/' + response.data.uniqueResponseID);
            });
        }
    }
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);

    };
    return (
        <div>

            { foundID ?
                <React.Fragment>
                    {loading ? <LoadingWheel message={loadingMessage} /> :
       
                <div>
                    <div className="content">
                        <Paper square elevation={0}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="Tabs"
                            >
                                <Tab label="Summary" />
                                {type == "update" ? <Tab label="Summary of changes" /> : []}
                            </Tabs>
                        </Paper>
                        <div>&nbsp;</div>
                        {value == 0 ?
                            <React.Fragment>
                                        <p>This page provides a summary of your responses and links to support resources and services that can assist you further with the digital uplift of your subject site. A summary of the resources available on this page, grouped into the 4 categories in the DUC is available in the <a href="https://ltc.uow.edu.au/hub/unlisted/duc-support-resources" target="_blank">Learning & Teaching Hub.</a></p>
                                {responseMeta.faculty && responseMeta.faculty.length > 0 ?
                                    <p><strong>Faculty:</strong> {responseMeta.faculty}<br />
                                        <strong>School:</strong> {responseMeta.unit}</p>
                                    :
                                    <p><strong>Unit:</strong> {responseMeta.unit}, {responseMeta.entity}</p>
                                        }
                                        <div><strong>Unique ID:</strong> {uniqueID}</div>
                                        <div className="important"><strong>Important:</strong> Make note of your unique ID (above) before you exit. This will ensure you can retrieve and/or update your DUC in the future.</div>
                                        <p><a href={"form/" + uniqueID + "/duc" + (responseMeta.isInternal ? "?ltc=" : '')} className="link-small">Update this DUC</a></p>
                                {categories.length > 0 ? categories.map((c, i) =>
                                    <div key={c.categoryID}><h2>{c.categoryText}</h2>
                                        <table className="summaryTable">
                                            <thead>
                                                <tr>
                                                    <th>Checkpoint</th><th>Rating</th><th>Comments</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {questionResponses.length > 0 ?
                                                    questions.map((q) => filterQuestions(q, c.categoryID))
                                                    : <tr />}
                                            </tbody>
                                        </table>
                                        {c.showSupport ? <div>
                                            <h3>Support resources</h3>
                                            <div dangerouslySetInnerHTML={{ __html: c.categoryResources }} />
                                            <br />
                                        </div>
                                            
                                            : <div />
                                        }
                                    </div>
                                )

                                    : <div />}

                                        <p><a href={"form/" + uniqueID + "/duc" + (responseMeta.isInternal ? "?ltc=" : '')} className="link-small">Update this DUC</a></p>

                            </React.Fragment> :
                            <React.Fragment>
                                <p>This section summarises the updates you have just made to your DUC. The tables below show your responses from the last DUC you completed, your updated DUC as of today, and an indication of which checkpoint ratings you have changed.</p>
                                        <div><strong>Unique ID:</strong> {uniqueID}</div>
                                        <div className="important"><strong>Important:</strong> Make note of your unique ID (above) before you exit. This will ensure you can retrieve and/or update your DUC in the future.</div>
                                        <p><a href={"form/" + uniqueID + "/duc" + (responseMeta.isInternal ? "?ltc=" : '')} className="link-small">Update this DUC</a></p>
                                {categories.length > 0 ? categories.map((c, i) =>
                                    <div key={c.categoryID}><h2>{c.categoryText}</h2>
                                        <table className="summaryTable">
                                            <thead>
                                                <tr>
                                                    <th>Checkpoint</th><th>DUC completed on <Moment format="D MMMM YYYY">{ducs[1].createdDate}</Moment></th><th>DUC completed on <Moment format="D MMMM YYYY">{ducs[0].createdDate}</Moment></th><th>Rating change</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {questionResponses.length > 0 ?
                                                    combinedQuestions.map((q) => filterQuestions(q, c.categoryID))
                                                    : <tr />}
                                            </tbody>
                                        </table>

                                    </div>
                                )

                                            : <div />}
                                        <p><a href={"form/" + uniqueID + "/duc" + (responseMeta.isInternal ? "?ltc=" : '')} className="link-small">Update this DUC</a></p>
                            </React.Fragment>


                                }
                                <h2>Save your summary</h2>
                                <div><strong>Unique ID:</strong> {uniqueID}</div>
                                <div className="important"><strong>Important:</strong> Make note of your unique ID (above) before you exit. This will ensure you can retrieve and/or update your DUC in the future.</div>
                                <div className="call-to-action">
                                    <p><strong>Customise your summary</strong></p>
                                    <p>

                                        <IconButton aria-label="checkbox" size="small" color="primary" disableRipple={true} disableFocusRipple={true} onClick={() => setExcludeComment(!excludeComment)} >
                                    {excludeComment ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />} Exclude comments from saved copy
                                        </IconButton></p>
                                    <p>
                                        Subject name/code: <input type="text" placeholder="Enter subject name/code here" size="25" onChange={changeSubjectCode} /><br />
                                        <em>To ensure anonymity, this will only appear on your saved copy and will not be stored by the tool.</em>
                                        </p>
                                </div>

                                <p><a href="#" className="link-small" onClick={handleDownload}><DownloadIcon /> Save as a PDF</a><a href="#" ref={downloadLink} className="hidden" ></a></p>

                                <p> <span className="link-small"><MailIcon /> Send via email</span> <input type="text" placeholder="Enter your email here" onChange={changeEmailAddress} /> <a href="#" className="link-small" onClick={handleSend}>Send</a></p>
                                <p><em>Note: The tool does not store your email address.</em></p>
                                <p>Once you have saved or sent your DUC you can close this page or return to the <a href="home">DUC home page</a> to start a new DUC or view other options.</p>
                        <h2>Feedback</h2>
                        <a href="#" onClick={handleShowFeedback} className="link-small"><FeedbackIcon /> Provide feedback on the DUC Self-Assesment Tool</a>

                        {showFeedbackForm ?
                            <div className="call-to-action">
                                <FeedbackForm uniqueID={uniqueID} /></div>
                            : <div />}
                        <br />



                    </div>

                    </div>
             
                    }
                </React.Fragment>
                :
                <div>
                    {loading ? <LoadingWheel message={loadingMessage} /> : 
                        <React.Fragment>
                    <div className="content">
                        <h2>ID not found. Please try again.</h2>
                        {showError ? <span className="error">The unique ID you entered is not valid.</span> : <span />}
                        <IDInput onRecallIDChange={onRecallIDChange} />
                        <br />
                        <p>Still having trouble recalling an existing DUC?</p>
                        <a href="new/0" className="link-small">Start a new DUC</a>
                    </div>

                    <div className="page-nav">
                        <div><a href="/recall" className="link-small-back"> Back</a></div>
                        <div><a href="#" onClick={handleRecallNext} className="link-small">Next</a></div>
                            </div>
                        </React.Fragment>
                    }
                </div>


            }
        </div>

    )
}
export default Summary;